import React, { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';

import {
    DIGITAL_LABOR_LAW_POSTER,
    DIGITAL_LABOR_LAW_POSTER_COLUMNS,
    LOCAL_STORAGE,
    QUERY_KEYS,
} from '../../../constants';
import { Table } from '../../shared';
import { AdminPageHeader } from '../../Admin';
import { usePagination } from '../../../hooks';
import { getLocalStorageItem, popup } from '../../../utils';
import { getAllDigitalLaborLawPoster } from '../../../utils/apiServices/digitalLaborLawPosterAPI';
import { useDebouncedValue } from '../../../hooks/useDebounceValue';

export const DigitalLaborLawPostersCustomer = () => {
    const [response, setResponse] = useState({
        data: [],
        count: 1,
    });
    const pagination = usePagination(response.data.length, response.count);
    const [search, setSearch] = useState('');
    const accountId = getLocalStorageItem(LOCAL_STORAGE.CUSTOMER_ID);

    const [debounceSearch] = useDebouncedValue(search, 500);
    const { data, isFetching, isFetched, isError, error } = useQuery({
        queryKey: [
            QUERY_KEYS.DIGITAL_LABOR_POSTERS,
            accountId,
            debounceSearch,
            pagination.limit,
            pagination.offset,
        ],
        queryFn: async () =>
            await getAllDigitalLaborLawPoster({
                account_id: accountId,
                limit: pagination.limit,
                offset: pagination.offset,
                search: search,
            }),
        select: (data) => ({ data: data.data, count: data.count }),
        placeholderData: { data: [], count: 0 },
        enabled: !!accountId,
    });

    useEffect(() => {
        if (isFetched && data?.data) {
            setResponse({ data: data.data, count: data.count });
        }
    }, [data, isFetched]);

    if (isError) popup('error', error.message);

    return (
        <>
            <AdminPageHeader
                heading={DIGITAL_LABOR_LAW_POSTER.PAGE_HEADING}
                buttonText={DIGITAL_LABOR_LAW_POSTER.ADD_BUTTON_TEXT}
                backbutton
                showSearchBar
                searchBarPlaceholder={DIGITAL_LABOR_LAW_POSTER.FILE_NAME_SEARCH}
                count={pagination.dataCount}
                setSearch={setSearch}
            />

            <Table
                columns={DIGITAL_LABOR_LAW_POSTER_COLUMNS.filter((c) =>
                    ['File Name', 'Uploaded At', 'Action'].includes(c.name),
                )}
                data={response.data}
                pagination={pagination}
                pageName={DIGITAL_LABOR_LAW_POSTER.PAGE_HEADING}
                stickyColumns={['File Name']}
                isLoading={isFetching}
            />
        </>
    );
};
